import {useNavigate} from "react-router-dom";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import {useContext, useEffect, useState} from "react";
import YesNo from "../../components/YesNo.jsx";
import {useErrorTranslation} from "../../api/utilities/translateErrorMessage.js";
import {useTranslation} from "react-i18next";
import LoadingComponent from "../../components/LoadingComponent.jsx";
import useDownloadState from "../../api/utilities/useDownloadState.js";
import {ProjectApi} from "../../api/authority/generated/index";
import toast from "react-hot-toast";

export default function DeleteProjectYesNo({visible, setVisible, project}) {
    let {getAuthorityConfiguration, resetCurrentUserProjects} = useContext(GlobalContext);

    let navigate = useNavigate();

    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let [yesPressed, setYesPressed] = useState(false);
    let [state, setDownloading] = useDownloadState();

    useEffect(() => {

        if (!yesPressed) {
            return;
        }

        setYesPressed(false);

        setDownloading(true);

        new ProjectApi(getAuthorityConfiguration())
            .deleteProject({
                projectId: project.id,
            })
            .then(() => {
                toast.success(t('project.project-deleted'));
                resetCurrentUserProjects();
                navigate('/projects');
            })
            .catch((e) => et(e).then((message) => { if (message) toast.error(message); }))
            .finally(() => {
                setDownloading(false);
                setVisible(false);
            });

    }, [yesPressed]);

    return (<YesNo
        title={t('confirmation')}
        question={t('project.really-delete-project-question', {projectName: project.name})}
        loading={state.downloading}
        visible={visible}
        setVisible={setVisible}
        onYes={() => {
            setYesPressed(true);
            setVisible(true);
        }}
    />);
}